
import {Component, Mixins, Prop} from 'vue-property-decorator';
import PazConfirmation from "../../../components/utils/PazConfirmation.vue";
import PazTooltipButton from "../../../components/controls/PazTooltipButton.vue";
import {b64toBlob, dateObjToDisplay} from "../../../helpers/Helper";
import {IDossierFile} from "../../../models/dossier.model";
import {authentication} from '../../../store';
import {deleteDossierFile, getFileUrl, updateDossierFile} from "@pazion/pazion-core/src/services/dossier-service";
import PermissionService from "@pazion/pazion-core/src/services/permission-service";

@Component({
  components: {
    PazConfirmation,
    PazTooltipButton
  },
  methods: {dateObjToDisplay}
})
export default class DossierFile extends Mixins(PermissionService) {

  $refs!: {
    confirm: PazConfirmation
  };
  @Prop({default: 0})
  public dossierId!: number;
  @Prop()
  public file!: IDossierFile;
  public hideMe: boolean = false;
  public isDownloading: boolean = false;
  public verifiedCache:string  = '';
  public isUpdating: boolean = false;

  get useDossierVerifier(){
    return this.hasFeatureFlag('dossierManagement.verifyDossier');
  }

  created() {
  }

  mounted() {
    this.verifiedCache = this.file.verified ?? '';
  }

  get isVerified() {
    return 'oke' == this.verifiedCache;
  }

  get isRejected() {
    return 'reject' == this.verifiedCache;
  }


  get isUserUpload(): boolean {
    return this.file?.user != undefined;
  }

  get isAdmin() {
    return authentication.isAdmin;
  }

  get canDelete(): boolean {
    return authentication.isAdmin || authentication.getProfile?.id == this.file?.user?.id;
  }

  async verifyFile(verifyStatus: string) {
    this.isUpdating = true;
    let rsp = await updateDossierFile(this.file.id, {verified: verifyStatus});
    this.verifiedCache = rsp.verified ?? '';
    this.isUpdating = false;
  }

  async deleteFile() {
    if (!this.canDelete) {
      return;
    }
    if (!await this.$refs.confirm.openConfirmDialog('Verwijderen', 'Weet je zeker dat je dit bestand wil verwijderen?')) {
      return;
    }
    const rsp = await deleteDossierFile(this.file.id);
    if (rsp.success) {
      this.$emit('refreshDataRequest');
    }
  }

  async downloadFile() {
    this.isDownloading = true;
    let fileRequest = await getFileUrl(this.file.id);
    const fileURL = window.URL.createObjectURL(b64toBlob(fileRequest.content, this.file.fileExtension));
    const fileLink = document.createElement('a');

    fileLink.href = fileURL;
    fileLink.setAttribute('download', this.file.fileName);
    document.body.appendChild(fileLink);

    fileLink.click();
    this.isDownloading = false;


  }


  get getDescription() {
    if (this.file.description.length > 0) {
      return this.file.description;
    }
    return this.file.fileName;
  }

}
